/**
 * Represents the possible backend modules.
 */
export enum ApiEndpoint {
    Pub,
    Core
}